import { render, staticRenderFns } from "./TextBand.vue?vue&type=template&id=1994665c&scoped=true&"
var script = {}
import style0 from "./TextBand.vue?vue&type=style&index=0&id=1994665c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1994665c",
  null
  
)

export default component.exports